module.exports = __webpack_public_path__ + "static/media/christian.fcc49233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/christian.jpg
// module id = 604
// module chunks = 0